import { EventConfigurationFieldName } from './event-configuration.types';
import { EquipmentListingFieldName } from '../../equipment/devices/components/devices.models';
import { SEARCH_HINTS } from '../../../shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';

export const eventConfigurationTableSortField: Record<string, EquipmentListingFieldName> = {
  commodity: EventConfigurationFieldName.Commodity,
  deviceTypeName: EventConfigurationFieldName.DeviceType,
  eventConfigurationStatus: EventConfigurationFieldName.IsEnabled,
  eventGroup: EventConfigurationFieldName.EventGroup,
  lastUpdateTimestamp: EventConfigurationFieldName.LastUpdateTimestamp,
  name: EventConfigurationFieldName.Name,
  updatedBy: EventConfigurationFieldName.UpdatedBy,
  unitOfMeasure: EventConfigurationFieldName.UnitOfMeasure
};

export const EVENTS_SEARCH_TYPES = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.ALL,
    value: 1,
    types: [
      EventConfigurationFieldName.Description,
      EventConfigurationFieldName.EventGroup,
      EventConfigurationFieldName.Name,
      EventConfigurationFieldName.UpdatedBy
    ],
    hintText: SEARCH_HINTS.EventGroupOrNameOrDescriptionOrUserName
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.DESCRIPTION,
    value: 2,
    types: [EventConfigurationFieldName.Description],
    hintText: SEARCH_HINTS.Description
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.EVENT_GROUP,
    value: 3,
    types: [EventConfigurationFieldName.EventGroup],
    hintText: SEARCH_HINTS.EventGroup
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.EVENT_NAME,
    value: 4,
    types: [EventConfigurationFieldName.Name],
    hintText: SEARCH_HINTS.EventName
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.USER_NAME,
    value: 5,
    types: [EventConfigurationFieldName.UpdatedBy],
    hintText: SEARCH_HINTS.UserName
  }
];

export const EVENTS_SEARCH_MAX_LENGTH = 64;
export const EVENTS_SEARCH_MAX_WIDTH = 36.5;
